import helpContents from './helpContents';
import { Overlay, Modal, CloseBtn, StepList, StepItem } from './HelpModal.styles';

const HelpModal = ({ page, onClose }) => {
    const content = helpContents[page] || helpContents.default;

    return (
        <Overlay onClick={onClose}>
            <Modal onClick={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <span className="modalTitle">{content.title}</span>
                    <CloseBtn onClick={onClose}>×</CloseBtn>
                </div>
                <StepList>
                    {content.steps.map((step, i) => (
                        <StepItem key={i}>
                            <span className="stepIcon">{step.icon}</span>
                            <span className="stepText">{step.text}</span>
                        </StepItem>
                    ))}
                </StepList>
            </Modal>
        </Overlay>
    );
};

export default HelpModal;
